import FieldDropdown from "../../../../fields3/generic/dropdown/dropdown"
import ContactTypePopoverMenuMore from "./components/popover-menu-more"
import FieldConfig from "../../../proto/field-config"
import FieldContactType_GlistGroupStandard from "./components/glist-group/standard"
import FieldCrmContactType_ValueEmpty from "./components/value/value-empty"
import FieldCrmContactType_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldCrmContactType_View from "./components/view/view"
import FieldCrmContactType_PopoverOption from "./components/popover-option"
import FieldCrmContactType_FormValue from "./components/form/value"

export default class FieldCrmContactType extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Crm Contact Type"

        this.options            = gd.company.settings.modules.crmContact.contactTypes;

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = _.get(config,'addNoValueOption',true);

        // Label for no value option
        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','General');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.icon = 'i5-crm-contact';

        this.isSearchable = true;

        this.components.PopoverMenuMore     = ContactTypePopoverMenuMore
        this.components.PopoverOption       = FieldCrmContactType_PopoverOption

        this.classes.PopoverMenu            = 'w-250'
        this.components.glistGroupStandard  = FieldContactType_GlistGroupStandard
        this.components.InlineValueEmpty    = FieldCrmContactType_ValueEmpty
        this.components.InlineValueNotEmpty = FieldCrmContactType_InlineValueNotEmpty
        this.components.FormValueEmpty      = FieldCrmContactType_FormValue
        this.components.FormValueNotEmpty   = FieldCrmContactType_FormValue

        this.renderComponents.view          = FieldCrmContactType_View
    }

    groupValue(value:any) {
        return _.get(this._getOption(value),'value', null);
    }

    groupSortValue(value:any) {
        return _.indexOf(this.options, this._getOption(value));
    }

}
